import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.513 15a3.99 3.99 0 0 1-1.196 2.852q.134.09.261.19a5 5 0 0 1 1.778 2.71 1 1 0 1 1-1.937.496 3 3 0 0 0-2.742-2.251 4 4 0 0 1-.33 0 3 3 0 0 0-2.74 2.251 1 1 0 0 1-1.938-.496 5 5 0 0 1 2.04-2.9A4 4 0 1 1 15.512 15m-6 0a2 2 0 1 1 2.15 1.994 5 5 0 0 0-.301 0A2 2 0 0 1 9.512 15"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18 14a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1M18 18a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 5a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 2h22v18H5z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconIdentificationCard = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconIdentificationCard);
export default Memo;
